import { Component, Inject, OnInit } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ActivatedRoute } from '@angular/router'
import { NotificationService } from '../../../../../../notification/shared/notification.service'
import { Client } from '../../../../../shared/client/client'
import { TypeLingerie } from '../../shared/lingerie'
import { LingerieService } from '../../shared/lingerie.service'

@Component({
  selector: 'app-add-lingerie-modal',
  templateUrl: './add-lingerie-modal.component.html',
  styleUrls: [
    './add-lingerie-modal.component.scss'
  ]
})
export class AddLingerieModalComponent implements OnInit {

  public form = new UntypedFormGroup({
    nom: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('', [Validators.required])
  })

  public types: TypeLingerie[] = null
  client: Client

  constructor(
    public dialogRef: MatDialogRef<AddLingerieModalComponent>,
    private route: ActivatedRoute,
    private lingerieService: LingerieService,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: Client,
  ) { }

  ngOnInit(): void {
    this.client = this.data

    this.lingerieService.getClientTypesLingeries(this.client).subscribe((types) => {
      types.sort((a, b) => {
        if (a.libelle == "Autre") return 1
        if (b.libelle == "Autre") return -1
        if (a.libelle < b.libelle) return -1
        if (a.libelle > b.libelle) return 1
        if (a.libelle == b.libelle) return 0
      })
      this.types = types
      if (types.length == 1) {
        this.form.get('type').setValue([types[0].id])
        this.form.controls['type'].disable()
      } else {
        this.form.controls['type'].enable()
      }
    }, error => {
      this.dialogRef.close()
    })
  }

  onSubmit() {
    if (this.form.valid) {
      let listTypes = []
      if (this.types.length == 1) {
        listTypes.push(this.types[0])
      } else {
        this.form.value.type.forEach(typeId => {
          listTypes.push(this.types.find(value => value.id == typeId))
        })
      }

      let datas = { libelle: this.form.value.nom, type: listTypes }
      this.lingerieService.postLingerieClient(this.client.id, datas).subscribe((lingerie) => {
        this.notificationService.notif("Lingerie '" + this.form.value.nom + "' crée", "notif")
        this.dialogRef.close(this.form.value.nom)
      })
    }
  }

  refuse() {
    this.dialogRef.close(false)
  }
}